export default function preloaderGame5 (scene) {

    scene.load.image(`tilesgame5`, `/tiles/game5.png`);
    scene.load.image(`tilesgame5_door1`, `/tiles/game5-door-1.png`);
    scene.load.image(`tilesgame5_door2`, `/tiles/game5-door-2.png`);
    scene.load.image(`tilesgame5_door3`, `/tiles/game5-door-3.png`);

	scene.load.audio("whatSong", ["/audio/songs/5-what.mp3"]);

	scene.load.spritesheet(`monito-game5`, 
		`/img/game5/monito.png`,
		{ frameWidth: 13, frameHeight: 22}
	);
	
	scene.load.spritesheet(`monito2-game5`, 
		`/img/game5/monito2.png`,
		{ frameWidth: 15, frameHeight: 22}
	);
	
	scene.load.spritesheet(`jiu-game5`, 
		`/img/game5/jiu.png`,
		{ frameWidth: 26, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game5`, 
		`/img/game5/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game5`, 
		`/img/game5/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game5`, 
		`/img/game5/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game5`, 
		`/img/game5/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game5`, 
		`/img/game5/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game5`,
		`/img/game5/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.tilemapTiledJSON(`game5`, `/tiles/game5.tmj`);

}